const Checkmark = ({
  className = "",
  color,
}: {
  className?: string;
  color: string;
}): JSX.Element => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      data-name="layer1"
      d="M54.626 9.372a32 32 0 1 0 0 45.254 32 32 0 0 0 0-45.254zM47.37 26.456l-17.38 17.38-10.407-10.407a2 2 0 1 1 2.828-2.828l7.578 7.578 14.553-14.55a2 2 0 0 1 2.828 2.827z"
      fill={color}
    ></path>
  </svg>
);

export default Checkmark;
